const hspt3 = gsap.timeline({ paused: true });

hspt3.fromTo('.home-progress-header .sec-header-content-anim-line', {
    x: 0,
    y: 49,
    z: -41,
    rotationX: -80,
    transformOrigin: '50% 0%',
    opacity: 0,
},
    {
        x: 0,
        y: 0,
        z: 0,
        rotationX: 0,
        transformOrigin: '318px 30px',
        opacity: 1,
        stagger: 0.05,
        duration: 0.9,
        ease: 'power4.out'
    })

ScrollTrigger.create({
    trigger: ".home-progress-header",
    start: '0% 80%',
    // end: '100% 70%',
    // markers: true,
    onEnter: () => hspt3.play(),
    onLeaveBack: () => hspt3.reverse()
})

const hpci1 = gsap.timeline({ paused: true });
hpci1.fromTo('.home-progress-count-item', {
    y: -50,
    opacity: 0,
}, {
    y: 0,
    opacity: 1,
    stagger: 0.1,
    duration: 0.9,
    ease: "bounce.out",
});

const counters = document.querySelectorAll(".count-digit");
const counterContainer = document.querySelector(".home-progress-count");

let countActivated = false;

function updateCounters() {
    counters.forEach(counter => {
        const target = parseInt(counter.dataset.count);
        let count = 0;
        const increment = () => {
            if (count < target) {
                count++;
                counter.innerText = count;
                setTimeout(increment, 20);
            }
        };
        increment();
    });
}

ScrollTrigger.create({
    trigger: ".home-progress-count-wrapp",
    start: '0% 80%',
    // markers: true,
    onEnter: () => {
        hpci1.play();
        updateCounters()
    },
    onLeaveBack: () => {
        // Reset countActivated when leaving the viewport
        countActivated = false;
        hpci1.reverse();
    }
});

// hps == home progress section
const hps = gsap.timeline({
    scrollTrigger: {
        trigger: '.home-progress',
        start: "-10% 40%",
        end: "100% 60%",
        scrub: true,
        // markers: true,
    }
})
hps.to('.header-bg', {
    backgroundColor: 'rgb(21, 23, 30)',
}, 'hps')
hps.to('.header-contact-cta-link a', {
    backgroundColor: '#2758d0',
}, 'hps')